import { DocumentFunctionRegistry } from '../types';

export const createEmptyDocumentFunctionRegistry =
    (): DocumentFunctionRegistry => ({
        actions: {},
        inputHandlers: {},
        customInputs: {},
        repeaterHandlers: {},
        viewHandlers: {},
        backgrounds: {},
        richTextExtensions: {},
        searchProviders: {},
    });
